.label {
  composes: btnClean from '../utils.module.css';
  display: flex;
  align-items: center;
  padding: 0.375rem 0.75rem;
  white-space: nowrap;
}

.label:hover {
  background-color: var(--h5w-selector-option-hover--bgColor, whitesmoke);
}

.text {
  margin-left: 0.375rem;
}
